if (!customElements.get("best-sellers")) {
  class BestSellers extends HTMLElement {
    constructor() {
      super();
      this.collectionURL = this.dataset.url;
      this.sectionId = this.dataset.sectionId;
      this.collectionHandle = this.dataset.handle;
      this.container = this.querySelector(".best-sellers");
    }

    connectedCallback() {
      console.log(this.collectionHandle);

      // fetch(
      //   window.Shopify.routes.root +
      //     `collections/${this.collectionHandle}?sort_by=best-selling&section_id=${this.sectionId}`
      // )
      //   .then((response) => response.text())
      //   .then((data) => {
      //     const html = new DOMParser().parseFromString(data, "text/html");
      //     console.log("NEW HTML", html);
      //     this.container.replaceWith(html.querySelector(".best-sellers"));
      //   });
    }
  }

  customElements.define("best-sellers", BestSellers);
}
